import styled from 'styled-components';

const UserPermissions = styled.div`
  width: 100%;
  padding: 20px;
`;

export default UserPermissions;
